/** metres for anything under a kilometre, one decimal kilometre above that */
export const formatDistancePointTemplate = (meters: number): string => {
	if (!isFinite(meters) || meters < 0) {
		return ''
	}
	if (meters < 1000) {
		return `${Math.round(meters)} м`
	}
	return `${(meters / 1000).toFixed(1)} км`
}
